var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A3A3A3",
    d: "M8.167 3.5V1.173c.035.029.07.064.099.093l3.302 3.302c.029.029.064.064.093.099H9.333A1.17 1.17 0 0 1 8.167 3.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A3A3A3",
    d: "M12.215 5.833H9.333A2.333 2.333 0 0 1 7 3.5V.618a2.149 2.149 0 0 0-.385-.035H3.5a1.75 1.75 0 0 0-1.75 1.75v9.334a1.75 1.75 0 0 0 1.75 1.75h7a1.75 1.75 0 0 0 1.75-1.75V6.218c0-.129-.012-.258-.035-.385M4.083 8.167h2.334a.583.583 0 0 1 0 1.166H4.083a.583.583 0 0 1 0-1.166m5.834 3.5H4.083a.583.583 0 0 1 0-1.167h5.834a.584.584 0 0 1 0 1.167"
  })));
};
export default SvgFile;